module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/advertizing_pre_test-87aff7cfd818945d43f89a4127579ca1.png";